
define('inlineSvg!svgs/icon/arrow-down', function () {return '<span class="inline-arrow-down inline-icon"><svg width="24" height="18" viewBox="-0.525 -4 24 18" overflow="visible"><path d="M23.2.7L12.7 9.1l-1.1.9-1.1-.898L0 .7.5 0l11.1 6.3L22.7 0l.5.7z"/></svg></span>';});

